import { Box } from "@mui/material";
import ReactQuill from "react-quill";
import { Editor_ModuleConfig } from "../../constant/ApplicationVariables";


export default function CustomEditor({ value, handleUpdateValue, placeholderMessage, containerFixedHeight, editorHeight }) {


    const handleChange = (val) => {
        handleUpdateValue(val);
    }


    return (
        <Box className="w-full flex flex-col gap-0 "
            sx={{
                height: containerFixedHeight ? containerFixedHeight : "131px", // set the height of the Box component to 100%
                overflowY: "auto",
                "& .ql-container": {
                    // height: "40px",
                    maxHeight: editorHeight ? editorHeight : "83%",
                    // overflowY: "auto"
                }
            }} >

            <ReactQuill
                theme="snow"
                // styles={{
                //     height: '80px', // set the height of the editor
                // }}
                value={value}
                onChange={handleChange}
                placeholder={placeholderMessage ? placeholderMessage : "Write something..."}
                modules={{ ...Editor_ModuleConfig }}
            />

        </Box>
    )
}
